import Snack from '@effectivastudio/snackbar';
import {
  csrfFetch,
  execJSFromResponse,
  appendScript,
} from '../../lib/helpers.js';

export class CommonActions {
  constructor(el) {
    this.el = el;
  }

  appendScript(text) {
    appendScript(text);
  }

  confirmDialog(msg = 'Are you sure?') {
    return confirm(msg);
  }

  throwError(res) {
    throw new Error(res);
  }

  onFetchError(res) {
    this.el.dispatchEvent(
      new Event('ajax:error', { bubbles: true, composed: true })
    );
    this.el.dispatchEvent(
      new Event('ajax:complete', { bubbles: true, composed: true })
    );

    this.throwError(res);
  }

  onFetchSuccess() {
    this.el.dispatchEvent(
      new Event('ajax:success', { bubbles: true, composed: true })
    );
    this.el.dispatchEvent(
      new Event('ajax:complete', { bubbles: true, composed: true })
    );
  }

  showSnack(msg, cssClass) {
    Snack({
      text: msg,
      customClass: cssClass,
    });
  }

  displaySnackBarError(msg) {
    this.showSnack(msg || 'Something went wrong', 'snackbar-danger');
  }

  displaySnackBarSuccess(msg) {
    this.showSnack(msg || 'Success', 'snackbar-default');
  }

  visit(url, { target, turbolinksAction = 'advance' } = {}) {
    if (target) {
      window.open(url, target);
    } else {
      window.Turbolinks?.visit(url, { action: turbolinksAction });
    }
  }

  async fetch(url, opts = {}) {
    this.el.dispatchEvent(
      new Event('ajax:beforeSend', { bubbles: true, composed: true })
    );

    try {
      const res = await csrfFetch(url, opts);
      const headerContentType = res.headers.get('content-type');

      this.onFetchSuccess();
      if (headerContentType?.includes('text/javascript;')) {
        this.appendScript(await res.text());
      } else {
        return res;
      }
    } catch (catchRes) {
      this.onFetchError(catchRes);
    }
  }

  get(url, opts = {}) {
    return this.fetch(url, {
      method: 'GET',
      ...opts,
    });
  }

  patch(url, opts = {}) {
    return this.fetch(url, {
      method: 'PATCH',
      ...opts,
    });
  }

  post(url, opts = {}) {
    return this.fetch(url, {
      method: 'POST',
      ...opts,
    });
  }

  put(url, opts = {}) {
    return this.fetch(url, {
      method: 'PUT',
      ...opts,
    });
  }

  delete(url, opts = {}) {
    return this.fetch(url, {
      method: 'DELETE',
      ...opts,
    });
  }

  async execJSFromResponse(url, options) {
    this.el.dispatchEvent(
      new Event('ajax:beforeSend', { bubbles: true, composed: true })
    );

    try {
      await execJSFromResponse(url, options);
      this.onFetchSuccess();
    } catch (catchRes) {
      this.displaySnackBarError();
      this.onFetchError(catchRes);
    }
  }
}

export default CommonActions;
